<template>
    <div class="card-body" :id="'userDashlet-' + userDashlet.id">
        <div class="row">
            <div class="col-8">
                <h5 v-if="!title">{{ $trans.get("__JSON__." + dashlet_type) }}</h5>
                <h5 v-if="title">{{ title }}</h5>
            </div>
            <div class="col-4" v-if="editUserDashlet">
                <div class="row text-center ml-auto">

                    <button v-if="hideCompareButton == false" type="button" @click="openModal('comparison')"
                        class="col-3 btn btn-outline-info mb-1 ml-1 text-align-center" v-tooltip
                        :title="$trans.get('__JSON__.compare')">
                        <span class="material-symbols-outlined d-flex justify-content-center align-items-center ">
                            compare
                        </span></button>
                    <button v-if="hideCompareButton == false" type="button" @click="openModalExpandDashlet"
                        class="col-3 btn btn-outline-info mb-1 ml-1 d-flex justify-content-center align-items-center"
                        v-tooltip :title="$trans.get('__JSON__.expand')">
                        <span class="material-symbols-outlined">
                            open_in_full </span></button>
                    <button type="button" @click="" data-bs-html="true" v-tooltip
                        class="col-3 btn btn-outline-info mb-1 ml-1 d-flex justify-content-center align-items-center"
                        data-bs-custom-class="info-tooltip"
                        :title="userDashlet.dashlet_database">
                        <span class="material-symbols-outlined">
                            info
                        </span></button>

                </div>
                <div class="row">
                    <div v-if="thresholdable" class="col-12">
                        <span v-if="editUserDashlet.pivot.threshold_active == 0 && hideThresholdButtons == false"
                            @click="add_notification_click" type="button"
                            class="float-end material-add-icon material-symbols-outlined">
                            notification_add </span>

                        <span v-if="editUserDashlet.pivot.threshold_active == 0 && hideThresholdButtons == false"
                            class="float-end material-inactive-icon material-symbols-outlined"> notifications_off
                        </span>

                        <span v-if="editUserDashlet.pivot.threshold_active == 1 && hideThresholdButtons == false"
                            @click="edit_notification_click" type="button"
                            class="float-end material-edit-icon material-symbols-outlined"> edit_notifications </span>

                        <span v-if="editUserDashlet.pivot.threshold_active == 1 && hideThresholdButtons == false"
                            class="float-end material-active-icon material-symbols-outlined"> notifications_active
                        </span>
                    </div>
                    <div v-else class="col-12">
                        <span style="visibility: hidden"
                            class="float-end material-inactive-icon material-symbols-outlined"> block
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="chart-container" style="position: relative;">
            <canvas v-show="!loading" :id="'canvas' + uuid"></canvas>
            <div v-show="loading" class="spinner-border text-danger" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>

    <!-- Modal Edit Threshold-->
    <Teleport to="body">
        <div :id="'thresholdsModal-' + userDashlet.name" class="modal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="editUserDashlet">
                    <div class="modal-header">
                        <h2>
                            {{ $trans.get("__JSON__.Set or edit thresholdnotifications") }}</h2>
                        <button @click.prevent="closeModalResetUserDashlet" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <h5>
                                    {{ $trans.get("__JSON__." + userDashlet.name) }}
                                </h5>
                            </div>
                            <div class="col-12">
                                <label for="checkbox_thresholdactive" class="text-left pt-2 mr-3 ml-3">
                                    {{ $trans.get("__JSON__.threshold notification on / off") }}
                                </label>
                                <input class="" type="checkbox" id="checkbox_thresholdactive"
                                    v-model='editUserDashlet.pivot.threshold_active' true-value="1" false-value="0">
                            </div>
                            <div class="col-12">
                                <label class="text-left pt-2 mr-3 ml-3">
                                    {{ $trans.get("__JSON__.threshold value") }}
                                </label>
                                <input :id="'trhd-' + userDashlet.name" class="" type="number"
                                    v-model='editUserDashlet.pivot.threshold_value'>
                            </div>
                        </div>
                    </div>
                    <div v-if="userDashletsPatch_errors != null" class="alert alert-danger" role="alert">
                        <div v-for="error in userDashletsPatch_errors"> {{ error[0] }} </div>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="closeModalResetUserDashlet" class="btn btn-secondary"
                            data-bs-dismiss="modal">Abbrechen</button>
                        <button @click.prevent="buttonThresholdDatasSaveClick"
                            class="btn btn-primary">Speichern</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>

    <!-- ComparisonModal -->
    <Teleport to="body">
        <div :id="'comparisonModal-' + userDashlet.name" class="modal modal-fade">
            <div class="modal-dialog modal-90">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="row">
                            <h2 class="col-12"> {{ $trans.get("__JSON__.comparison") }} </h2>
                            <h3 class="col-12"> {{ $trans.get("__JSON__." + userDashlet.name) }} </h3>
                            <div class="row ">
                                <h3 class="col-4 ">{{ $trans.get("__JSON__.Filters from dashboard") }}</h3>
                                <table class="table col-8">
                                    <thead>
                                        <tr>
                                            <th scope="col">{{ $trans.get("__JSON__.Teams") }}</th>
                                            <th scope="col">{{ $trans.get("__JSON__.Employers") }}</th>
                                            <th scope="col">{{ $trans.get("__JSON__.Locations") }}</th>
                                            <th scope="col">{{ $trans.get("__JSON__.Divisions") }}</th>
                                            <th scope="col">{{ $trans.get("__JSON__.Dategroup") }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ teamname }}</td>
                                            <td>{{ employername }}</td>
                                            <td>{{ locationname }}</td>
                                            <td>{{ divisionname }}</td>
                                            <td>{{ $trans.get("__JSON__." + date_filter_option_id) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <button @click.prevent="clearBothSelects" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <h5>
                            {{ $trans.get("__JSON__.comparison by") }}
                        </h5>
                        <div class="row">
                            <div class="col-4 container">
                                <div class="btn-group" v-for="compareOption in compareOptions" role="group"
                                    aria-label="Basic radio toggle button group">
                                    <input :value="compareOption.value" type="radio" class="btn-check mr-2"
                                        name="'btnradio-'" :id="'btnradio-' + compareOption.value + userDashlet.name"
                                        autocomplete="off" v-model="optionSelected" @change="clearSecondSelect">
                                    <label class="btn btn-primary"
                                        :for="'btnradio-' + compareOption.value + userDashlet.name">
                                        {{ compareOption.label.de }}</label>
                                </div>
                            </div>
                            <Multiselect class="col-6 multiselect-green" v-if="optionSelected > 0"
                                v-model="selectedCompareItems" mode="tags" :close-on-select="false" :searchable="true"
                                :create-option="false" :options="compareItems" locale="de" fallback="en" />
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4"
                                v-for="dashletProperty of compareDashletProperties">
                                <Dashlet :team_id="dashletProperty.team_id" :employer_id="dashletProperty.employer_id"
                                    :location_id="dashletProperty.location_id"
                                    :division_id="dashletProperty.division_id"
                                    :date_filter_option_id="this.date_filter_option_id" :to_Date="this.to_Date"
                                    :dashlet_type="this.dashlet_type" :userDashlet="this.userDashlet"
                                    :employers="this.employers" :hideThresholdButtons="true" :hideCompareButton="true"
                                    :title="dashletProperty.title">
                                </Dashlet>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="clearBothSelects" class="btn btn-secondary"
                            data-bs-dismiss="modal">Abbrechen</button>
                        <!-- <button @click.prevent="" class="btn btn-primary">Anzeigen</button> -->
                    </div>
                </div>
            </div>
        </div>
    </Teleport>

    <!-- BigSingleDashletModal -->
    <Teleport to="body">
        <div :id="'bigSingleDashletModal-' + userDashlet.name" class="modal modal-fade">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-body" :id="'userDashlet-' + userDashlet.id">
                            <div class="row">
                                <div class="col-11"></div>
                                <div class="col-1">
                                    <div class="row  float-end">
                                        <div class="col-12">
                                            <button type="button" @click="closeModalExpandDashlet"
                                                class=" float-endd btn btn-info mb-1 ml-1" v-tooltip
                                                :title="$trans.get('__JSON__.collapse')">
                                                <span class="material-symbols-outlined">
                                                    close_fullscreen
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="enlarged_dashlet">
                                <Dashlet :team_id="this.team_id" :employer_id="this.employer_id"
                                    :location_id="this.location_id" :division_id="this.division_id"
                                    :date_filter_option_id="this.date_filter_option_id" :to_Date="this.to_Date"
                                    :dashlet_type="this.dashlet_type" :userDashlet="this.userDashlet"
                                    :employers="this.employers" :title="this.title" :hideThresholdButtons="true"
                                    :hideCompareButton="true">
                                </Dashlet>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>

    <!-- DetailListModal -->
    <Teleport to="body">
        <div v-if="userDashlet.clickable" :id="'detailListModal-' + userDashlet.name" class="modal modal-fade">
            <div class="modal-dialog modal-90">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="row">
                            <h2 class="col-12"> {{ $trans.get("__JSON__.Details") }} </h2>
                            <h3 class="col-12"> {{ $trans.get("__JSON__." + userDashlet.name) }} </h3>
                            <div class="row">
                                <div class="col-6">
                                    <h5 v-if="details"> {{ $trans.get("__JSON__.Date") }}: {{ details.dateinfo }} </h5>
                                    <h5 v-if="details">{{ $trans.get('__JSON__.Count data sets') }}: {{ details.count }}<br></h5>
                                    <div class="row">
                                        <div class="col-4">{{ $trans.get("__JSON__.Team") }}:</div>
                                        <div class="col-8">{{ this.teamname }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-4">{{ $trans.get("__JSON__.Employer") }}:</div>
                                        <div class="col-8">{{ this.employername }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-4">{{ $trans.get("__JSON__.Location") }}:</div>
                                        <div class="col-8">{{ this.locationname }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-4">{{ $trans.get("__JSON__.Division") }}:</div>
                                        <div class="col-8">{{ this.divisionname }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button @click.prevent="clearBothSelects" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <employeedaysover10hdetails :teamId="team_id" 
                                                    :employerId="employer_id"
                                                    :locationId="location_id"
                                                    :divisionId="division_id"
                                                    :date_filter_value="details.dateinfo"
                                                    :date_filter_option_id="date_filter_option_id" >
                        </employeedaysover10hdetails>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="" class="btn btn-secondary"
                            data-bs-dismiss="modal">Abbrechen</button>
                        <!-- <button @click.prevent="" class="btn btn-primary">Anzeigen</button> -->
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style>
.info-tooltip.tooltip > .tooltip-inner{
  max-width: 600px !important;
  width: 500px !important;
  text-align: left !important;
}
</style>

<script>

import getDashletDatas from '../../composables/getDashletDatas';
import { Chart, LogarithmicScale } from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
//import ChartDataLabels from 'chartjs-plugin-datalabels';
import zoomPlugin from 'chartjs-plugin-zoom';
import userDashletsHandling from "../../composables/UserDashlets";
import Multiselect from '@vueform/multiselect';
import { v4 as uuidv4 } from 'uuid';

export default {
    setup(props) {
        const { dashletDatas, dashletDatas_error, loadDashletDatas } = getDashletDatas();
        const { userDashletsPatch_errors, patchUserDashlets } = userDashletsHandling();

        return {
            dashletDatas, dashletDatas_error, loadDashletDatas, userDashletsPatch_errors, patchUserDashlets
        };
    },
    components: {
        Multiselect,
    },
    props: {
        team_id: Number,
        employer_id: Number,
        location_id: Number,
        division_id: Number,
        date_filter_option_id: String,
        to_Date: String,
        dashlet_type: String,
        userDashlet: Object,
        employers: Object,
        teams: Object,
        divisions: Object,
        locations: Object,
        hideThresholdButtons: Boolean,
        hideCompareButton: Boolean,
        title: String,
        thresholdable: Number,
    },
    data() {
        return {
            uuid: uuidv4(),
            myChart: null,
            ctx: null,
            editUserDashlet: null,
            optionSelected: 0,
            compareOptions: [{ value: 1, label: { en: 'team', de: "Teams" } },
            { value: 2, label: { en: 'employer', de: 'Arbeitgeber' } },
            { value: 3, label: { en: 'location', de: 'Standorte' } },
            { value: 4, label: { en: 'division', de: 'Abteilungen' } },
            ],
            selectedCompareItems: null,
            teamname: null,
            employername: null,
            locationname: null,
            divisionname: null,
            loading: 0,
            enlarged_dashlet: null,
            details: {},
        }
    },
    emits:['renderingCompleted'],
    computed: {
        compareItems() {
            var items = [];

            var selectedSubOption = this.compareOptions.find((compareOption) => compareOption.value == this.optionSelected);
            switch (selectedSubOption.label.en) {

                case 'team':
                    this.teams.forEach(element => {
                        const team = {
                            value: element.id,
                            label: element.name
                        };
                        items.push(team);
                    });
                    break;

                case 'location':
                    this.locations.forEach(element => {
                        const location = {
                            value: element.id,
                            label: element.name
                        };
                        items.push(location);
                    });
                    break;

                case 'employer':
                    this.employers.forEach(element => {
                        const employer = {
                            value: element.id,
                            label: element.name
                        };
                        items.push(employer);
                    });
                    break;

                case 'division':
                    this.divisions.forEach(element => {
                        const division = {
                            value: element.id,
                            label: element.name
                        };
                        items.push(division);
                    });
                    break;
            }
            return items;
        },
        compareDashletProperties() {
            var dashlets = [];
            if (!this.selectedCompareItems) {
                return dashlets;
            }
            const selectedCompareItems = { ...this.selectedCompareItems };
            var dashletProperties = {
                team_id: this.team_id,
                employer_id: this.employer_id,
                location_id: this.location_id,
                division_id: this.division_id,
                title: null
            };
            //console.log("CompareItems: ", this.compareItems);
            //console.log("THISselectedCompareItems: ", this.selectedCompareItems);
            //console.log("selectedCompareItems: ", selectedCompareItems);
            var selectedSubOption = this.compareOptions.find((compareOption) => compareOption.value == this.optionSelected);

            this.selectedCompareItems.forEach(element => {
                dashletProperties.title = this.compareItems.find((compareItem) => compareItem.value == element).label;
                switch (selectedSubOption.label.en) {
                    case 'team':
                        dashletProperties.team_id = element;
                        dashlets.push({ ...dashletProperties });
                        break;

                    case 'location':
                        dashletProperties.location_id = element;
                        dashlets.push({ ...dashletProperties });
                        break;

                    case 'division':
                        dashletProperties.division_id = element;
                        dashlets.push({ ...dashletProperties });
                        break;

                    case 'employer':
                        dashletProperties.employer_id = element;
                        dashlets.push({ ...dashletProperties });
                        break;
                }

            })
            return dashlets;
        },

    },
    watch: {
        dashlet_type(newValue, oldValue) {
            if (this.myChart) {
                this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
            }
        },
        dashletDatas: {
            handler: function (newValue, oldValue) {
                if (oldValue != newValue) {
                    this.renderChart();
                }
            },
            deep: true,
        },
        team_id(newValue, oldValue) {
            this.myChart.destroy();
            this.loading = 1;
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
        },
        employer_id(newValue, oldValue) {
            this.myChart.destroy();
            this.loading = 1;
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
        },
        location_id(newValue, oldValue) {
            this.myChart.destroy();
            this.loading = 1;
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
        },
        division_id(newValue, oldValue) {
            this.myChart.destroy();
            this.loading = 1;
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
        },
        date_filter_option_id(newValue, oldValue) {
            this.myChart.destroy();
            this.loading = 1;
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);

        },
        to_Date(newValue, oldValue) {
            this.myChart.destroy();
            this.loading = 1;
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);

        },
        userDashlet(newValue, oldValue) {
            this.editUserDashlet = JSON.parse(JSON.stringify(this.userDashlet));
        },
    },
    created() {
        this.editUserDashlet = JSON.parse(JSON.stringify(this.userDashlet));
        $(() => {
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
        });
    },
    mounted() {
        Chart.register(annotationPlugin);
        // Chart.register(ChartDataLabels);
        Chart.register(zoomPlugin);
    },
    methods: {
        renderChart() {
            try {
                if (this.myChart) {
                    this.myChart.destroy();
                }
                var canvas = document.getElementById('canvas' + this.uuid);

                this.myChart = new Chart(canvas,
                    this.dashletDatas
                );
                this.loading = 0;
                canvas.onclick = this.clickHandler;
                this.$emit('renderingCompleted',1);

            }
            catch (error) {                            // Step 2: Error get caught here
                console.error(error);
                this.$emit('renderingCompleted',1);
            }
        },
        clickHandler(click) {
            const points = this.myChart.getElementsAtEventForMode(click,'nearest', {intersect: true}, true);
            if(points.length) {
                const firstPoint = points[0];
                const label = this.myChart.data.labels[firstPoint.index];
                const value = this.myChart.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
                this.details['dateinfo'] = label;
                this.details['count'] = value;
                this.openModal('detailList');
            }
        },
        add_notification_click() {
            $('#thresholdsModal-' + this.userDashlet.name).modal({ backdrop: 'static', keyboard: false });
            $('#thresholdsModal-' + this.userDashlet.name).modal("show");

        },
        edit_notification_click() {
            $('#thresholdsModal-' + this.userDashlet.name).modal({ backdrop: 'static', keyboard: false });
            $('#thresholdsModal-' + this.userDashlet.name).modal("show");
        },
        async buttonThresholdDatasSaveClick() {
            await this.patchUserDashlets(this.editUserDashlet);
            if (this.userDashletsPatch_errors == null) {
                $('#thresholdsModal-' + this.userDashlet.name).modal("hide");
                this.dashletDatas = null;
                this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
            }
        },
        closeModalResetUserDashlet() {
            this.editUserDashlet = JSON.parse(JSON.stringify(this.userDashlet));
            this.loadDashletDatas(this.team_id, this.employer_id, this.location_id, this.division_id, this.date_filter_option_id, this.to_Date, this.dashlet_type);
            $('#thresholdsModal-' + this.userDashlet.name).modal("hide");
        },
        openModal(modaltype) {
            $(".tooltip").css("display", "none");
            if (!this.team_id == 0) {
                this.teamname = this.teams.find((team) => team.id == this.team_id).name;
            }
            else { this.teamname = "All teams" }

            if (!this.employer_id == 0) {
                this.employername = this.employers.find((employer) => employer.id == this.employer_id).name;
            }
            else { this.employername = "All employers" }

            if (!this.location_id == 0) {
                this.locationname = this.locations.find((location) => location.id == this.location_id).name;
            }
            else { this.locationname = "All locations" }

            if (!this.division_id == 0) {
                this.divisionname = this.divisions.find((division) => division.id == this.division_id).name;
            }
            else { this.divisionname = "All divisions" }

            let modalNamePart = '';
            switch(modaltype) {
                case 'comparison':
                    modalNamePart = '#comparisonModal-';
                    break;
                case 'detailList':
                    modalNamePart = '#detailListModal-';
                    break;
            }

            $(modalNamePart + this.userDashlet.name).modal({ backdrop: 'static', keyboard: false });
            $(modalNamePart + this.userDashlet.name).modal("show");
        },
        clearSecondSelect() {
            this.selectedCompareItems = null;
        },
        clearBothSelects() {
            this.subSelectAcivated = false;
            this.subOptions = [];
            this.optionSelected = null;
            this.subOptionsSelected = null;
        },
        openModalExpandDashlet() {
            $(".tooltip").css("display", "none");
            if (!this.team_id == 0) {
                this.teamname = this.teams.find((team) => team.id == this.team_id).name;
            }
            else { this.teamname = "All teams" }

            if (!this.employer_id == 0) {
                this.employername = this.employers.find((employer) => employer.id == this.employer_id).name;
            }
            else { this.employername = "All employers" }

            if (!this.location_id == 0) {
                this.locationname = this.locations.find((location) => location.id == this.location_id).name;
            }
            else { this.locationname = "All locations" }

            if (!this.division_id == 0) {
                this.divisionname = this.divisions.find((division) => division.id == this.division_id).name;
            }
            else { this.divisionname = "All divisions" }

            this.enlarged_dashlet = this.dashlet_type;
            $('#bigSingleDashletModal-' + this.userDashlet.name).modal({ backdrop: 'static', keyboard: false });
            $('#bigSingleDashletModal-' + this.userDashlet.name).modal("show");
        },
        closeModalExpandDashlet() {
            $(".tooltip").css("display", "none");
            $('#bigSingleDashletModal-' + this.userDashlet.name).modal("hide");
        },
    },
}
</script>